const COOKIE_NAME = "platform_attribution";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
const QUERY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "ttclid",
  "ctwa_clid",
];

const object = (value) =>
  value && typeof value === "object" && !Array.isArray(value) ? value : {};

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  const row = document.cookie.split(";").map((item) => item.trim()).find((item) => item.startsWith(prefix));
  return row ? decodeURIComponent(row.slice(prefix.length)) : null;
}

function readStoredAttribution() {
  try {
    return object(JSON.parse(readCookie(COOKIE_NAME) || "{}"));
  } catch {
    return {};
  }
}

export function capturePlatformAttribution() {
  if (typeof window === "undefined") return { first_touch: {}, last_touch: {} };
  const params = new URLSearchParams(window.location.search);
  const current = {};
  for (const key of QUERY_KEYS) {
    const value = params.get(key);
    if (value) current[key] = value.slice(0, 500);
  }
  const fbp = readCookie("_fbp");
  const existingFbc = readCookie("_fbc");
  if (fbp) current.fbp = fbp;
  if (existingFbc) current.fbc = existingFbc;
  if (!current.fbc && current.fbclid) current.fbc = `fb.1.${Date.now()}.${current.fbclid}`;
  current.landing_page = window.location.href.slice(0, 2048);
  if (document.referrer) current.referrer = document.referrer.slice(0, 2048);

  const stored = readStoredAttribution();
  const firstTouch = Object.keys(object(stored.first_touch)).length
    ? stored.first_touch
    : current;
  const value = { first_touch: firstTouch, last_touch: current };
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(value))}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
  return value;
}

export function getPlatformAttribution() {
  const stored = readStoredAttribution();
  return Object.keys(stored).length ? stored : capturePlatformAttribution();
}
